import { render, staticRenderFns } from "./LightningIcon.vue?vue&type=template&id=46a3fbc5&"
import script from "./LightningIcon.vue?vue&type=script&lang=js&"
export * from "./LightningIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports